import React from 'react';
import SVG from '../../../editJournal/toolset/hoc/SVG';

export const PersonalInfoIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Personal Info Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16637_1902)">
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 12C1.25 8.73923 1.25 7.10885 1.76492 5.8165C2.50185 3.96695 3.96695 2.50185 5.8165 1.76492C7.10885 1.25 8.73923 1.25 12 1.25C15.2608 1.25 16.8912 1.25 18.1835 1.76492C20.0331 2.50185 21.4982 3.96695 22.2351 5.8165C22.75 7.10885 22.75 8.73923 22.75 12C22.75 15.2608 22.75 16.8912 22.2351 18.1835C21.701 19.524 20.7844 20.6625 19.6161 21.4683C18.5364 18.3561 15.5982 16.25 12.2798 16.25H11.7202C8.4018 16.25 5.46359 18.3561 4.38386 21.4683C3.21562 20.6625 2.29902 19.524 1.76492 18.1835C1.25 16.8912 1.25 15.2608 1.25 12ZM7.25 10C7.25 7.37665 9.37665 5.25 12 5.25C14.6234 5.25 16.75 7.37665 16.75 10C16.75 12.6234 14.6234 14.75 12 14.75C9.37665 14.75 7.25 12.6234 7.25 10Z"
        fill="#03000A"
      />
      <path
        d="M12 6.75C10.2051 6.75 8.75 8.20507 8.75 10C8.75 11.7949 10.2051 13.25 12 13.25C13.7949 13.25 15.25 11.7949 15.25 10C15.25 8.20507 13.7949 6.75 12 6.75Z"
        fill="#03000A"
      />
      <path
        d="M5.72266 22.1974C5.75344 22.2102 5.78433 22.2227 5.81532 22.2351C7.10767 22.75 8.73806 22.75 11.9988 22.75C15.2596 22.75 16.89 22.75 18.1823 22.2351C18.2133 22.2227 18.2442 22.2102 18.275 22.1974C17.4742 19.5568 15.0395 17.75 12.2787 17.75H11.719C8.95814 17.75 6.52344 19.5568 5.72266 22.1974Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16637_1902">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const WorkExperienceIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Work Experience Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16637_1909)">
      <path
        opacity="0.4"
        d="M15.2498 16.7499V16.9999C15.2498 17.4141 15.5855 17.7499 15.9998 17.7499C16.414 17.7499 16.7498 17.4141 16.7498 16.9999V16.7499H16.9998C19.583 16.7499 21.3934 16.2359 22.5748 15.3499C22.6342 15.3053 22.6918 15.26 22.7477 15.2139C22.7386 16.7634 22.6913 17.6699 22.4439 18.4313C21.8257 20.334 20.3339 21.8258 18.4312 22.444C17.4897 22.7499 16.3264 22.7499 13.9998 22.7499H9.99981C7.67321 22.7499 6.50991 22.7499 5.56846 22.444C3.66572 21.8258 2.17395 20.334 1.55571 18.4313C1.30833 17.6699 1.26101 16.7634 1.25195 15.214C1.30778 15.26 1.36536 15.3054 1.42475 15.3499C2.60608 16.2359 4.4165 16.7499 6.99975 16.7499H7.24975V16.9999C7.24975 17.4141 7.58554 17.7499 7.99975 17.7499C8.41397 17.7499 8.74975 17.4141 8.74975 16.9999V16.7499H15.2498Z"
        fill="#03000A"
      />
      <path
        d="M1.25781 12.2241C1.30865 12.9377 1.61165 13.615 2.32496 14.15C3.14363 14.764 4.58321 15.25 6.99996 15.25H7.24996V15C7.24996 14.5858 7.58574 14.25 7.99996 14.25C8.41417 14.25 8.74996 14.5858 8.74996 15V15.25H15.25V15C15.25 14.5858 15.5857 14.25 16 14.25C16.4142 14.25 16.75 14.5858 16.75 15V15.25H17C19.4167 15.25 20.8563 14.764 21.675 14.15C22.3887 13.6147 22.6917 12.9368 22.7422 12.2227C22.7235 11.0073 22.6599 10.2328 22.4441 9.56864C21.8259 7.66591 20.3341 6.17413 18.4314 5.5559C17.4899 5.25 16.3266 5.25 14 5.25H10C7.67341 5.25 6.51011 5.25 5.56866 5.5559C3.66592 6.17413 2.17415 7.66591 1.55591 9.56864C1.34004 10.233 1.27651 11.0079 1.25781 12.2241Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 2.75C9.42893 2.75 7.75 4.42893 7.75 6.5C7.75 6.91421 7.41421 7.25 7 7.25C6.58579 7.25 6.25 6.91421 6.25 6.5C6.25 3.60051 8.6005 1.25 11.5 1.25H12.5C15.3995 1.25 17.75 3.60051 17.75 6.5C17.75 6.91421 17.4142 7.25 17 7.25C16.5858 7.25 16.25 6.91421 16.25 6.5C16.25 4.42893 14.5711 2.75 12.5 2.75H11.5Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16637_1909">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const EducationIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Education Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16642_2368)">
      <path
        d="M10.9479 7.15085C11.5926 6.75202 12.4074 6.75202 13.0521 7.15085L17.1143 9.66367C17.7036 10.0282 18.0622 10.6717 18.0622 11.3645V16.6355C18.0622 17.3283 17.7036 17.9718 17.1143 18.3363L13.0521 20.8492C12.4074 21.248 11.5926 21.248 10.9479 20.8492L6.88568 18.3363C6.29643 17.9718 5.93782 17.3283 5.93782 16.6355V11.3645C5.93782 10.6717 6.29643 10.0282 6.88568 9.66367L10.9479 7.15085Z"
        fill="#03000A"
        fillOpacity="0.4"
      />
      <path
        d="M11.0474 2.51597C11.6417 2.19409 12.3583 2.19409 12.9526 2.51597L20.7534 6.74142C22.15 7.4979 22.15 9.5021 20.7534 10.2586L12.9526 14.484C12.3583 14.8059 11.6417 14.8059 11.0474 14.484L3.24662 10.2586C1.85004 9.5021 1.85004 7.4979 3.24662 6.74142L11.0474 2.51597Z"
        fill="#03000A"
      />
      <rect x="19" y="7.5" width="2" height="8" rx="1" fill="#03000A" />
    </g>
    <defs>
      <clipPath id="clip0_16642_2368">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const SkillsIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Skills Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16642_2377)">
      <path
        opacity="0.4"
        d="M9.99931 2.82308C10.5081 0.725639 13.4919 0.725639 14.0007 2.82308C14.077 3.13818 14.2267 3.43079 14.4375 3.67711C14.6483 3.92343 14.9143 4.11649 15.2138 4.24059C15.5134 4.36468 15.8379 4.41629 16.1612 4.39123C16.4844 4.36617 16.7972 4.26514 17.074 4.09636C18.917 2.97358 21.0276 5.08297 19.9048 6.92719C19.7363 7.20389 19.6354 7.51646 19.6104 7.83948C19.5854 8.1625 19.637 8.48686 19.7609 8.7862C19.8849 9.08554 20.0777 9.35141 20.3238 9.5622C20.5698 9.77299 20.8621 9.92275 21.1769 9.99931C23.2744 10.5081 23.2744 13.4919 21.1769 14.0007C20.8618 14.077 20.5692 14.2267 20.3229 14.4375C20.0766 14.6483 19.8835 14.9143 19.7594 15.2138C19.6353 15.5134 19.5837 15.8379 19.6088 16.1612C19.6338 16.4844 19.7349 16.7972 19.9036 17.074C21.0264 18.917 18.917 21.0276 17.0728 19.9048C16.7961 19.7363 16.4835 19.6354 16.1605 19.6104C15.8375 19.5854 15.5131 19.637 15.2138 19.7609C14.9145 19.8849 14.6486 20.0777 14.4378 20.3238C14.227 20.5698 14.0773 20.8621 14.0007 21.1769C13.4919 23.2744 10.5081 23.2744 9.99931 21.1769C9.92296 20.8618 9.77329 20.5692 9.56248 20.3229C9.35168 20.0766 9.08569 19.8835 8.78617 19.7594C8.48664 19.6353 8.16205 19.5837 7.83881 19.6088C7.51557 19.6338 7.20282 19.7349 6.926 19.9036C5.08297 21.0264 2.97239 18.917 4.09517 17.0728C4.2637 16.7961 4.36457 16.4835 4.38958 16.1605C4.41458 15.8375 4.36301 15.5131 4.23906 15.2138C4.11511 14.9145 3.92228 14.6486 3.67624 14.4378C3.4302 14.227 3.1379 14.0773 2.82308 14.0007C0.725639 13.4919 0.725639 10.5081 2.82308 9.99931C3.13818 9.92296 3.43079 9.77329 3.67711 9.56248C3.92343 9.35168 4.11649 9.08569 4.24059 8.78617C4.36468 8.48664 4.41629 8.16205 4.39123 7.83881C4.36617 7.51557 4.26514 7.20282 4.09636 6.926C2.97358 5.08297 5.08297 2.97239 6.92719 4.09517C8.12164 4.82139 9.66964 4.17878 9.99931 2.82308Z"
        fill="#03000A"
      />
      <path
        d="M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16642_2377">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const LanguagesIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Languages Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16640_2071)">
      <path
        opacity="0.4"
        d="M7.54774 16.4456C5.4454 16.0012 3.39371 15.2388 1.4668 14.1572C2.32254 18.3577 5.62772 21.6674 9.82574 22.5298C8.74932 20.6048 7.98951 18.5518 7.54774 16.4456Z"
        fill="#03000A"
      />
      <path
        d="M12.283 1.25365C12.189 1.25122 12.0946 1.25 12 1.25C11.9054 1.25 11.811 1.25122 11.717 1.25365C10.5169 3.14107 9.66298 5.17796 9.1535 7.27766C11.0431 7.02537 12.9579 7.02457 14.8457 7.27427C14.3361 5.17577 13.4824 3.14006 12.283 1.25365Z"
        fill="#03000A"
      />
      <path
        d="M15.1597 8.83559C13.068 8.504 10.9337 8.50483 8.83966 8.83966C8.50483 10.9337 8.504 13.068 8.83559 15.1597C10.9323 15.4954 13.0694 15.4962 15.1638 15.1638C15.4962 13.0694 15.4954 10.9323 15.1597 8.83559Z"
        fill="#03000A"
      />
      <path
        d="M1.25365 11.717C3.14107 10.5169 5.17796 9.66298 7.27766 9.1535C7.02537 11.0431 7.02457 12.9579 7.27427 14.8457C5.17576 14.3361 3.14006 13.4824 1.25365 12.283C1.25122 12.189 1.25 12.0946 1.25 12C1.25 11.9054 1.25122 11.811 1.25365 11.717Z"
        fill="#03000A"
      />
      <path
        d="M16.7215 9.14714C18.8245 9.65422 20.8618 10.5056 22.7459 11.6997C22.7486 11.7994 22.75 11.8996 22.75 12C22.75 12.1004 22.7486 12.2006 22.7459 12.3003C20.8628 13.4937 18.8267 14.3449 16.7249 14.852C16.9757 12.9601 16.9749 11.0409 16.7215 9.14714Z"
        fill="#03000A"
      />
      <path
        d="M14.852 16.7249C12.9601 16.9757 11.0409 16.9749 9.14714 16.7215C9.65422 18.8245 10.5056 20.8618 11.6997 22.7459C11.7994 22.7486 11.8996 22.75 12 22.75C12.1004 22.75 12.2006 22.7486 12.3003 22.7459C13.4937 20.8628 14.3449 18.8267 14.852 16.7249Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M14.1738 22.5303C15.2493 20.607 16.0087 18.5559 16.4507 16.4516C18.5549 16.0097 20.606 15.2503 22.5293 14.1748C21.6681 18.3671 18.3662 21.669 14.1738 22.5303Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M7.55328 7.55328C7.99754 5.44901 8.76025 3.3954 9.84282 1.4668C5.63669 2.3237 2.3237 5.63669 1.4668 9.84282C3.3954 8.76025 5.44901 7.99754 7.55328 7.55328Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M22.5307 9.82574C20.6058 8.74932 18.5528 7.98951 16.4466 7.54774C16.0021 5.4454 15.2398 3.39371 14.1582 1.4668C18.3586 2.32254 21.6684 5.62772 22.5307 9.82574Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16640_2071">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const CertificationsIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Certifications Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16640_2122)">
      <path
        opacity="0.4"
        d="M5.82953 3.07097L7.84317 2.15289C9.1482 1.5579 10.5657 1.25 12 1.25C13.4343 1.25 14.8518 1.5579 16.1568 2.15289L18.1705 3.07097C20.0463 3.92619 21.25 5.79792 21.25 7.8595V12.8456C21.25 15.6768 19.8404 18.3221 17.4904 19.901L14.2876 22.0529C13.6112 22.5073 12.8148 22.75 12 22.75C11.1852 22.75 10.3888 22.5073 9.71244 22.0529L6.50964 19.901C4.15962 18.3221 2.75 15.6768 2.75 12.8456V7.85949C2.75 5.79792 3.95372 3.92619 5.82953 3.07097Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9429 9.39477C16.2772 9.63936 16.3499 10.1086 16.1053 10.4429L14.3483 12.8442L14.3411 12.8536C13.4044 14.0524 12.3237 14.7993 11.0935 14.7476C9.88706 14.6968 8.83053 13.8859 7.90902 12.7064C7.65401 12.38 7.71189 11.9086 8.0383 11.6536C8.36471 11.3986 8.83604 11.4565 9.09105 11.7829C9.91954 12.8434 10.613 13.226 11.1565 13.2489C11.6748 13.2707 12.3417 12.973 13.1519 11.9392L14.8948 9.55718C15.1393 9.22289 15.6086 9.15018 15.9429 9.39477Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16640_2122">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const AwardsIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Awards & Honors Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16638_1967)">
      <path
        opacity="0.4"
        d="M5 15C5 18.866 8.13401 22 12 22C15.866 22 19 18.866 19 15C19 11.134 15.866 8 12 8C8.13401 8 5 11.134 5 15Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8945 12.362C13.1156 12.4987 13.2502 12.7401 13.2502 13V17C13.2502 17.4142 12.9144 17.75 12.5002 17.75C12.086 17.75 11.7502 17.4142 11.7502 17V14.2135L10.8356 14.6708C10.4651 14.8561 10.0146 14.7059 9.82934 14.3354C9.6441 13.9649 9.79427 13.5144 10.1648 13.3292L12.1648 12.3292C12.3972 12.2129 12.6734 12.2254 12.8945 12.362Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.26032 1.87682C4.32842 1.46824 4.71484 1.19223 5.12342 1.26032C8.34324 1.79696 11.6249 3.95682 12.7213 7.79408C12.8351 8.19235 12.6044 8.60747 12.2062 8.72126C11.8079 8.83505 11.3928 8.60443 11.279 8.20616C10.3753 5.04342 7.65699 3.20327 4.87682 2.73991C4.46824 2.67182 4.19223 2.2854 4.26032 1.87682Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.26181 4.86828C1.33462 4.46052 1.72421 4.18899 2.13197 4.26181C3.9299 4.58287 5.50333 5.07621 6.79244 5.93945C8.09938 6.81463 9.0687 8.03945 9.70276 9.73781C9.84763 10.1259 9.6505 10.5579 9.26244 10.7028C8.87439 10.8476 8.44237 10.6505 8.2975 10.2624C7.76488 8.8358 6.98421 7.87312 5.95782 7.18581C4.91359 6.48655 3.57035 6.04239 1.86828 5.73845C1.46052 5.66563 1.18899 5.27605 1.26181 4.86828Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7382 4.86828C22.6654 4.46052 22.2758 4.18899 21.868 4.26181C20.0701 4.58287 18.4967 5.07621 17.2076 5.93945C15.9006 6.81463 14.9313 8.03945 14.2972 9.73781C14.1524 10.1259 14.3495 10.5579 14.7376 10.7028C15.1256 10.8476 15.5576 10.6505 15.7025 10.2624C16.2351 8.8358 17.0158 7.87312 18.0422 7.18581C19.0864 6.48655 20.4296 6.04239 22.1317 5.73845C22.5395 5.66563 22.811 5.27605 22.7382 4.86828Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.74 1.87682C19.8081 2.2854 19.5321 2.67182 19.1235 2.73991C16.3433 3.20327 13.625 5.04342 12.7213 8.20616C12.6075 8.60443 12.1924 8.83505 11.7942 8.72126C11.3959 8.60747 11.1653 8.19235 11.2791 7.79408C12.3754 3.95682 15.6571 1.79696 18.8769 1.26032C19.2855 1.19223 19.6719 1.46824 19.74 1.87682Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16638_1967">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const ReferencesIcon = ({ height, width }) => (
  <SVG
    ariaLabel="References Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16640_2128)">
      <path
        opacity="0.4"
        d="M1.25 12C1.25 9.20653 1.25 7.80979 1.65707 6.69136C2.33949 4.81644 3.81644 3.33949 5.69136 2.65707C6.80979 2.25 8.20653 2.25 11 2.25H13C15.7935 2.25 17.1902 2.25 18.3086 2.65707C20.1836 3.33949 21.6605 4.81644 22.3429 6.69136C22.75 7.80979 22.75 9.20653 22.75 12C22.75 14.7935 22.75 16.1902 22.3429 17.3086C21.6605 19.1836 20.1836 20.6605 18.3086 21.3429C17.1902 21.75 15.7935 21.75 13 21.75H11C8.20653 21.75 6.80979 21.75 5.69136 21.3429C3.81644 20.6605 2.33949 19.1836 1.65707 17.3086C1.25 16.1902 1.25 14.7935 1.25 12Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 9C15.25 8.58579 15.5858 8.25 16 8.25H18C18.4142 8.25 18.75 8.58579 18.75 9C18.75 9.41421 18.4142 9.75 18 9.75H16C15.5858 9.75 15.25 9.41421 15.25 9Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 12C15.25 11.5858 15.5858 11.25 16 11.25H18C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75H16C15.5858 12.75 15.25 12.4142 15.25 12Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 15C15.25 14.5858 15.5858 14.25 16 14.25H18C18.4142 14.25 18.75 14.5858 18.75 15C18.75 15.4142 18.4142 15.75 18 15.75H16C15.5858 15.75 15.25 15.4142 15.25 15Z"
        fill="#03000A"
      />
      <path
        d="M6 10.5C6 12.1569 7.34315 13.5 9 13.5C10.6569 13.5 12 12.1569 12 10.5C12 8.84315 10.6569 7.5 9 7.5C7.34315 7.5 6 8.84315 6 10.5Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 13.75C7.75736 13.75 6.75 14.7574 6.75 16C6.75 16.4142 6.41421 16.75 6 16.75C5.58579 16.75 5.25 16.4142 5.25 16C5.25 13.9289 6.92893 12.25 9 12.25C11.0711 12.25 12.75 13.9289 12.75 16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16C11.25 14.7574 10.2426 13.75 9 13.75Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16640_2128">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const ProjectsIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Projects Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16640_2138)">
      <path
        opacity="0.4"
        d="M4 10V10.2585C4 12.0076 4.72397 13.6787 6 14.875L7.14169 15.9453C7.5225 16.3023 7.78874 16.7579 7.9156 17.2547C7.94331 17.2516 7.97147 17.25 8 17.25H11.25L11.25 12.6045C11.0742 12.5363 10.9057 12.4473 10.7435 12.344L9.60457 11.6373C9.2526 11.4189 9.14432 10.9565 9.36272 10.6046C9.58111 10.2526 10.0435 10.1443 10.3954 10.3627L11.5466 11.077C11.7725 11.2213 11.9098 11.25 12 11.25C12.0902 11.25 12.2275 11.2213 12.4534 11.0771L12.4617 11.0718L13.6046 10.3627C13.9565 10.1443 14.4189 10.2526 14.6373 10.6046C14.8557 10.9565 14.7474 11.4189 14.3954 11.6373L13.2565 12.344C13.0943 12.4473 12.9258 12.5363 12.75 12.6045V17.25H16C16.0285 17.25 16.0567 17.2516 16.0844 17.2547C16.2113 16.7579 16.4775 16.3023 16.8583 15.9453L18 14.875C19.276 13.6787 20 12.0076 20 10.2585V10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10Z"
        fill="#03000A"
      />
      <path
        d="M15.9299 18.75C15.5789 20.6006 13.9529 22 12.0001 22C10.0473 22 8.42137 20.6006 8.07031 18.75H15.9299Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16640_2138">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const PublicationsIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Publications Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16642_2243)">
      <path
        opacity="0.4"
        d="M3.25 10C3.25 7.6734 3.25 6.5101 3.5559 5.56864C4.17413 3.66591 5.66591 2.17413 7.56864 1.5559C8.5101 1.25 9.6734 1.25 12 1.25C14.3266 1.25 15.4899 1.25 16.4314 1.5559C18.3341 2.17413 19.8259 3.66591 20.4441 5.56864C20.75 6.5101 20.75 7.6734 20.75 10V14C20.75 16.3266 20.75 17.4899 20.4441 18.4314C19.8259 20.3341 18.3341 21.8259 16.4314 22.4441C15.4899 22.75 14.3266 22.75 12 22.75C9.6734 22.75 8.5101 22.75 7.56864 22.4441C5.66591 21.8259 4.17413 20.3341 3.5559 18.4314C3.25 17.4899 3.25 16.3266 3.25 14V10Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H15C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H9C8.58579 12.75 8.25 12.4142 8.25 12Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 8C8.25 7.58579 8.58579 7.25 9 7.25H15C15.4142 7.25 15.75 7.58579 15.75 8C15.75 8.41421 15.4142 8.75 15 8.75H9C8.58579 8.75 8.25 8.41421 8.25 8Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 16C8.25 15.5858 8.58579 15.25 9 15.25H12.9999C13.4141 15.25 13.7499 15.5858 13.7499 16C13.7499 16.4142 13.4141 16.75 12.9999 16.75H9C8.58579 16.75 8.25 16.4142 8.25 16Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16642_2243">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const VolunteerIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Volunteer Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16642_2399)">
      <path
        opacity="0.4"
        d="M11.1343 3.54195L11.7428 4.20168C11.8813 4.35186 12.1185 4.35186 12.257 4.20168L12.8654 3.54195C13.6363 2.70598 14.7217 2.23047 15.8589 2.23047C21.8169 2.23047 25.0366 9.21372 21.1676 13.7446L15.8237 20.0025C13.8164 22.3532 10.1833 22.3532 8.17601 20.0025L2.83214 13.7446C-1.03691 9.21373 2.18277 2.23047 8.14082 2.23047C9.27801 2.23047 10.3634 2.70598 11.1343 3.54195Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16642_2399">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const CoursesIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Courses Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.25 1.27975C13.6794 1.25 12.9648 1.25 12 1.25C11.0352 1.25 10.3206 1.25 9.75 1.27975V3C9.75 3.4762 9.75041 3.79579 9.76729 4.04326C9.78372 4.28398 9.81319 4.4012 9.84515 4.47835C9.97202 4.78464 10.2154 5.02798 10.5216 5.15485C10.5988 5.18681 10.716 5.21628 10.9567 5.23271C11.2042 5.24959 11.5238 5.25 12 5.25C12.4762 5.25 12.7958 5.24959 13.0433 5.23271C13.284 5.21628 13.4012 5.18681 13.4784 5.15485C13.7846 5.02798 14.028 4.78464 14.1549 4.47835C14.1868 4.4012 14.2163 4.28398 14.2327 4.04326C14.2496 3.79579 14.25 3.4762 14.25 3V1.27975Z"
      fill="#03000A"
    />
    <path
      opacity="0.4"
      d="M8.25 1.52246C6.41239 2.10937 4.98617 3.58197 4.46323 5.44837C4.25 6.20938 4.25 7.13949 4.25 8.9997V14.9997C4.25 16.8599 4.25 17.79 4.46323 18.551C5.00486 20.4842 6.51553 21.9948 8.44867 22.5365C9.20968 22.7497 10.1398 22.7497 12 22.7497C13.8602 22.7497 14.7903 22.7497 15.5513 22.5365C17.4845 21.9948 18.9951 20.4842 19.5368 18.551C19.75 17.79 19.75 16.8599 19.75 14.9997V8.9997C19.75 7.13949 19.75 6.20938 19.5368 5.44837C19.0138 3.58197 17.5876 2.10937 15.75 1.52246V3.02496C15.75 3.46942 15.75 3.84045 15.7292 4.14506C15.7076 4.46216 15.661 4.76169 15.5407 5.05208C15.2616 5.72591 14.7262 6.26126 14.0524 6.54037C13.762 6.66065 13.4625 6.70729 13.1454 6.72893C12.8408 6.74971 12.4697 6.74971 12.0253 6.7497H11.9747C11.5303 6.74971 11.1592 6.74971 10.8546 6.72893C10.5375 6.70729 10.238 6.66065 9.94762 6.54037C9.27379 6.26126 8.73844 5.72591 8.45933 5.05208C8.33905 4.76169 8.29241 4.46216 8.27077 4.14506C8.24999 3.84045 8.24999 3.46941 8.25 3.02495L8.25 1.52246Z"
      fill="#03000A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9941 17.5C10.9941 16.9477 11.4419 16.5 11.9941 16.5H12.0031C12.5554 16.5 13.0031 16.9477 13.0031 17.5C13.0031 18.0523 12.5554 18.5 12.0031 18.5H11.9941C11.4419 18.5 10.9941 18.0523 10.9941 17.5Z"
      fill="#03000A"
    />
  </SVG>
);

export const HobbiesIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Hobbies Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16640_2112)">
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3929 2.10938C10.3866 2.59857 8.50445 3.54622 6.90234 4.89642L6.73281 5.0393C6.12198 5.55408 5.5561 6.11996 5.04132 6.73079L4.89844 6.90032C3.54818 8.50251 2.60051 10.3848 2.11133 12.3911L3.05982 12.7073L3.07283 12.7122C6.86994 14.1361 9.866 17.1321 11.2899 20.9292L11.2948 20.9422L11.611 21.8908C13.6174 21.4016 15.4996 20.454 17.1018 19.1037L17.2714 18.9608C17.8822 18.446 18.4481 17.8802 18.9628 17.2693L19.1057 17.0998C20.456 15.4976 21.4037 13.6153 21.8928 11.609L20.9439 11.2926L20.9309 11.2877C17.1338 9.86383 14.1378 6.86777 12.7138 3.07066L12.709 3.05766L12.3929 2.10938Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6514 9.34869C14.9443 9.64158 14.9443 10.1165 14.6514 10.4093L10.4088 14.652C10.1159 14.9449 9.64102 14.9449 9.34812 14.652C9.05523 14.3591 9.05523 13.8842 9.34812 13.5913L13.5908 9.34869C13.8837 9.0558 14.3585 9.0558 14.6514 9.34869Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8232 9.70221C12.1161 9.40931 12.591 9.40931 12.8838 9.70221L14.2981 11.1164C14.591 11.4093 14.591 11.8842 14.2981 12.1771C14.0052 12.47 13.5303 12.47 13.2374 12.1771L11.8232 10.7629C11.5303 10.47 11.5303 9.9951 11.8232 9.70221Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.70209 11.8233C9.99499 11.5304 10.4699 11.5304 10.7628 11.8233L12.177 13.2375C12.4699 13.5304 12.4699 14.0053 12.177 14.2982C11.8841 14.5911 11.4092 14.5911 11.1163 14.2982L9.70209 12.884C9.4092 12.5911 9.4092 12.1162 9.70209 11.8233Z"
        fill="#03000A"
      />
      <path
        d="M22.1689 10.1192C22.2471 9.50522 22.2832 8.88354 22.2758 8.25834C22.2559 6.5699 21.5763 4.95624 20.3823 3.76225L20.2401 3.62009C19.0461 2.4261 17.4325 1.7465 15.744 1.72653C15.1187 1.71913 14.4969 1.75528 13.8828 1.83349L14.1238 2.55642C15.3959 5.93754 18.0643 8.60593 21.4454 9.87805L22.1689 10.1192Z"
        fill="#03000A"
      />
      <path
        d="M1.72946 15.7408C1.72206 15.1156 1.7582 14.4939 1.83638 13.8799L2.5595 14.1209C5.94063 15.393 8.60901 18.0614 9.88114 21.4426L10.1222 22.1657C9.50818 22.2439 8.88648 22.28 8.26126 22.2726C6.57283 22.2527 4.95917 21.5731 3.76518 20.3791L3.62302 20.2369C2.42903 19.0429 1.74943 17.4293 1.72946 15.7408Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16640_2112">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const SummaryIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Summary Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16640_2020)">
      <path
        opacity="0.4"
        d="M2.25 13C2.25 9.97138 2.25 8.45707 2.74478 7.26256C3.40449 5.66988 4.66988 4.40449 6.26256 3.74478C7.45707 3.25 8.97138 3.25 12 3.25C15.0286 3.25 16.5429 3.25 17.7374 3.74478C19.3301 4.40449 20.5955 5.66988 21.2552 7.26256C21.75 8.45707 21.75 9.97138 21.75 13C21.75 16.0286 21.75 17.5429 21.2552 18.7374C20.5955 20.3301 19.3301 21.5955 17.7374 22.2552C16.5429 22.75 15.0286 22.75 12 22.75C8.97138 22.75 7.45707 22.75 6.26256 22.2552C4.66988 21.5955 3.40449 20.3301 2.74478 18.7374C2.25 17.5429 2.25 16.0286 2.25 13Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 9C10 8.58579 10.3358 8.25 10.75 8.25L16.75 8.25C17.1642 8.25 17.5 8.58579 17.5 9C17.5 9.41421 17.1642 9.75 16.75 9.75L10.75 9.75C10.3358 9.75 10 9.41421 10 9Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 13C10 12.5858 10.3358 12.25 10.75 12.25L16.75 12.25C17.1642 12.25 17.5 12.5858 17.5 13C17.5 13.4142 17.1642 13.75 16.75 13.75L10.75 13.75C10.3358 13.75 10 13.4142 10 13Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 17C10 16.5858 10.3358 16.25 10.75 16.25L16.75 16.25C17.1642 16.25 17.5 16.5858 17.5 17C17.5 17.4142 17.1642 17.75 16.75 17.75L10.75 17.75C10.3358 17.75 10 17.4142 10 17Z"
        fill="#03000A"
      />
      <path
        d="M7.75 8C7.19772 8 6.75 8.44772 6.75 9C6.75 9.55228 7.19772 10 7.75 10C8.30228 10 8.75 9.55228 8.75 9C8.75 8.44772 8.30228 8 7.75 8Z"
        fill="#03000A"
      />
      <path
        d="M7.75 12C7.19772 12 6.75 12.4477 6.75 13C6.75 13.5523 7.19772 14 7.75 14C8.30228 14 8.75 13.5523 8.75 13C8.75 12.4477 8.30228 12 7.75 12Z"
        fill="#03000A"
      />
      <path
        d="M7.75 16C7.19772 16 6.75 16.4477 6.75 17C6.75 17.5523 7.19772 18 7.75 18C8.30228 18 8.75 17.5523 8.75 17C8.75 16.4477 8.30228 16 7.75 16Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.25C9.41421 1.25 9.75 1.58579 9.75 2V5C9.75 5.41421 9.41421 5.75 9 5.75C8.58579 5.75 8.25 5.41421 8.25 5V2C8.25 1.58579 8.58579 1.25 9 1.25Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.25C15.4142 1.25 15.75 1.58579 15.75 2V5C15.75 5.41421 15.4142 5.75 15 5.75C14.5858 5.75 14.25 5.41421 14.25 5V2C14.25 1.58579 14.5858 1.25 15 1.25Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16640_2020">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const ConferencesIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Conferences Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 4C1.25 2.48122 2.48122 1.25 4 1.25H20C21.5188 1.25 22.75 2.48122 22.75 4C22.75 5.51878 21.5188 6.75 20 6.75H4C2.48122 6.75 1.25 5.51878 1.25 4ZM4 2.75C3.30964 2.75 2.75 3.30964 2.75 4C2.75 4.69036 3.30964 5.25 4 5.25H20C20.6904 5.25 21.25 4.69036 21.25 4C21.25 3.30964 20.6904 2.75 20 2.75H4Z"
      fill="#03000A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 17.25C12.4142 17.25 12.75 17.5858 12.75 18V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V18C11.25 17.5858 11.5858 17.25 12 17.25Z"
      fill="#03000A"
    />
    <path
      opacity="0.4"
      d="M3.25 6V10C3.25 12.7966 3.25 14.1949 3.72603 15.2908C4.30653 16.6272 5.37275 17.6935 6.70919 18.274C7.80514 18.75 9.20342 18.75 12 18.75C14.7966 18.75 16.1949 18.75 17.2908 18.274C18.6272 17.6935 19.6935 16.6272 20.274 15.2908C20.75 14.1949 20.75 12.7966 20.75 10V6H3.25Z"
      fill="#03000A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6241 19.5841C12.8539 19.9287 12.7608 20.3944 12.4161 20.6241L9.4161 22.6241C9.07146 22.8539 8.60581 22.7608 8.37604 22.4161C8.14628 22.0715 8.23941 21.6058 8.58405 21.376L11.5841 19.376C11.9287 19.1463 12.3944 19.2394 12.6241 19.5841Z"
      fill="#03000A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.376 19.5841C11.6058 19.2394 12.0715 19.1463 12.4161 19.376L15.4161 21.376C15.7608 21.6058 15.8539 22.0715 15.6241 22.4161C15.3944 22.7608 14.9287 22.8539 14.5841 22.6241L11.5841 20.6241C11.2394 20.3944 11.1463 19.9287 11.376 19.5841Z"
      fill="#03000A"
    />
  </SVG>
);

export const AssociationsIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Associations Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16642_2353)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M10 1.25H6C3.92893 1.25 2.25 2.92893 2.25 5V22.75H13.75V5C13.75 2.92893 12.0711 1.25 10 1.25Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 8C6.25 7.58579 6.58579 7.25 7 7.25H9C9.41421 7.25 9.75 7.58579 9.75 8C9.75 8.41421 9.41421 8.75 9 8.75H7C6.58579 8.75 6.25 8.41421 6.25 8Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 12C6.25 11.5858 6.58579 11.25 7 11.25H9C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 16C6.25 15.5858 6.58579 15.25 7 15.25H9C9.41421 15.25 9.75 15.5858 9.75 16C9.75 16.4142 9.41421 16.75 9 16.75H7C6.58579 16.75 6.25 16.4142 6.25 16Z"
        fill="#03000A"
      />
      <path
        d="M21.75 22.75H15V19.25H17.5C17.9142 19.25 18.25 18.9142 18.25 18.5C18.25 18.0858 17.9142 17.75 17.5 17.75H15V15.25H17.5C17.9142 15.25 18.25 14.9142 18.25 14.5C18.25 14.0858 17.9142 13.75 17.5 13.75H15V11.25H17.5C17.9142 11.25 18.25 10.9142 18.25 10.5C18.25 10.0858 17.9142 9.75 17.5 9.75H15V6.25H18C20.0711 6.25 21.75 7.92893 21.75 10V22.75Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16642_2353">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const PatentsIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Patents Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16642_2301)">
      <path
        opacity="0.4"
        d="M3.25 18.9047V7.5C3.25 4.04822 6.04822 1.25 9.5 1.25H14.5C17.9518 1.25 20.75 4.04822 20.75 7.5V18.9047C20.75 21.0284 19.0284 22.75 16.9047 22.75C16.3193 22.75 15.7515 22.5496 15.2957 22.1822L15.0964 22.0215C13.2892 20.5645 10.7108 20.5645 8.90359 22.0215L8.70431 22.1822C8.24854 22.5496 7.68074 22.75 7.09529 22.75C4.9716 22.75 3.25 21.0284 3.25 18.9047Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 8C8.25 7.58579 8.58579 7.25 9 7.25H15C15.4142 7.25 15.75 7.58579 15.75 8C15.75 8.41421 15.4142 8.75 15 8.75H9C8.58579 8.75 8.25 8.41421 8.25 8Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16642_2301">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const TestScoresIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Test Scores Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16642_2196)">
      <path
        opacity="0.4"
        d="M1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12Z"
        fill="#03000A"
      />
      <path
        d="M8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3057 6.9955C17.5844 7.30199 17.5618 7.77633 17.2553 8.05496L15.0553 10.055C14.7488 10.3336 14.2745 10.311 13.9958 10.0045C13.7172 9.69802 13.7398 9.22368 14.0463 8.94505L16.2463 6.94505C16.5528 6.66642 17.0271 6.68901 17.3057 6.9955Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 13.001C4.94772 13.001 4.5 12.5533 4.5 12.001L4.5 12C4.5 11.4477 4.94772 11 5.5 11C6.05228 11 6.5 11.4477 6.5 12L6.5 12.001C6.5 12.5533 6.05228 13.001 5.5 13.001Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 17.5C6.69772 17.5 6.25 17.0523 6.25 16.5L6.25 16.499C6.25 15.9467 6.69772 15.499 7.25 15.499C7.80228 15.499 8.25 15.9467 8.25 16.499L8.25 16.5C8.25 17.0523 7.80228 17.5 7.25 17.5Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.75 17.5C16.1977 17.5 15.75 17.0523 15.75 16.5L15.75 16.499C15.75 15.9467 16.1977 15.499 16.75 15.499C17.3023 15.499 17.75 15.9467 17.75 16.499L17.75 16.5C17.75 17.0523 17.3023 17.5 16.75 17.5Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 13.001C17.9477 13.001 17.5 12.5533 17.5 12.001L17.5 12C17.5 11.4477 17.9477 11 18.5 11C19.0523 11 19.5 11.4477 19.5 12L19.5 12.001C19.5 12.5533 19.0523 13.001 18.5 13.001Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.50098C11.4477 6.50098 11 6.05326 11 5.50098L11 5.49998C11 4.94769 11.4477 4.49998 12 4.49998C12.5523 4.49998 13 4.94769 13 5.49998L13 5.50098C13 6.05326 12.5523 6.50098 12 6.50098Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.5C11.4477 19.5 11 19.0523 11 18.5L11 18.499C11 17.9467 11.4477 17.499 12 17.499C12.5523 17.499 13 17.9467 13 18.499L13 18.5C13 19.0523 12.5523 19.5 12 19.5Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 8.5C6.69772 8.5 6.25 8.05228 6.25 7.5L6.25 7.499C6.25 6.94672 6.69772 6.499 7.25 6.499C7.80228 6.499 8.25 6.94672 8.25 7.499L8.25 7.5C8.25 8.05228 7.80228 8.5 7.25 8.5Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16642_2196">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const LeadershipIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Leadership Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_16642_2362)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 21.6904C5.25 21.2762 5.58579 20.9404 6 20.9404L18 20.9404C18.4142 20.9404 18.75 21.2762 18.75 21.6904C18.75 22.1046 18.4142 22.4404 18 22.4404L6 22.4404C5.58579 22.4404 5.25 22.1046 5.25 21.6904Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M4.60629 16.328L1.6347 9.73945C0.568285 7.37501 3.2418 5.07804 5.41861 6.48849L6.64891 7.28566C7.22339 7.6579 7.99471 7.42063 8.26065 6.78987L9.92738 2.83679C10.7008 1.00232 13.3004 1.00232 14.0739 2.8368L15.7406 6.78987C16.0066 7.42063 16.7779 7.6579 17.3524 7.28566L18.5826 6.48849C20.7595 5.07804 23.433 7.37501 22.3666 9.73945L19.395 16.328C18.5463 18.2098 16.6735 19.4195 14.6092 19.4195H9.39204C7.32773 19.4195 5.45501 18.2098 4.60629 16.328Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15.001C11.4477 15.001 11 14.5533 11 14.001L11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14L13 14.001C13 14.5533 12.5523 15.001 12 15.001Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_16642_2362">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const ResearchExperienceIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Leadership Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_20083_1723)">
      <path
        d="M6 2V3.67545C6 7.45241 8.41686 10.8056 12 12C15.5831 13.1944 18 16.5476 18 20.3246V22"
        stroke="#03000A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 2V3.67545C18 7.45241 15.5831 10.8056 12 12C8.41686 13.1944 6 16.5476 6 20.3246V22"
        stroke="#03000A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.32"
        d="M7.5 8L16.5 8"
        stroke="#03000A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.32"
        d="M7.5 16L16.5 16"
        stroke="#03000A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 4L18 4"
        stroke="#03000A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 20L18 20"
        stroke="#03000A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_20083_1723">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const ExtraCurricularIcon = ({ height, width }) => (
  <SVG
    ariaLabel="Leadership Icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_20083_1677)">
      <path
        d="M8.25 19.5596V20.0004C8.25 21.5192 9.48122 22.7504 11 22.7504C12.5188 22.7504 13.75 21.5192 13.75 20.0004V19.5596C12.8852 19.8456 11.9607 20.0004 11 20.0004C10.0393 20.0004 9.11478 19.8456 8.25 19.5596Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M2.25 10C2.25 5.16751 6.16751 1.25 11 1.25C12.5298 1.25 13.9679 1.64258 15.219 2.33249C13.7476 3.13958 12.75 4.70329 12.75 6.5C12.75 9.12335 14.8766 11.25 17.5 11.25C18.3029 11.25 19.0593 11.0508 19.7225 10.6991C19.6514 11.5977 19.4446 12.4582 19.1225 13.26C19.0827 13.2534 19.0417 13.25 19 13.25H3C2.95827 13.25 2.91733 13.2534 2.87745 13.26C2.47272 12.2525 2.25 11.1522 2.25 10Z"
        fill="#03000A"
      />
      <path
        d="M3.65039 14.75C5.20932 17.1572 7.9187 18.75 11.0001 18.75C14.0815 18.75 16.7909 17.1572 18.3498 14.75H3.65039Z"
        fill="#03000A"
      />
      <path
        d="M14 6.5C14 8.433 15.567 10 17.5 10C19.433 10 21 8.433 21 6.5C21 4.567 19.433 3 17.5 3C15.567 3 14 4.567 14 6.5Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_20083_1677">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const AddIcon = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewbox="0 0 18 18"
    fill="#fff"
  >
    <path
      d="M9.00008 4.83366C8.54175 4.83366 8.16675 5.20866 8.16675 5.66699V8.16699H5.66675C5.20841 8.16699 4.83341 8.54199 4.83341 9.00033C4.83341 9.45866 5.20841 9.83366 5.66675 9.83366H8.16675V12.3337C8.16675 12.792 8.54175 13.167 9.00008 13.167C9.45841 13.167 9.83341 12.792 9.83341 12.3337V9.83366H12.3334C12.7917 9.83366 13.1667 9.45866 13.1667 9.00033C13.1667 8.54199 12.7917 8.16699 12.3334 8.16699H9.83341V5.66699C9.83341 5.20866 9.45841 4.83366 9.00008 4.83366ZM9.00008 0.666992C4.40008 0.666992 0.666748 4.40033 0.666748 9.00033C0.666748 13.6003 4.40008 17.3337 9.00008 17.3337C13.6001 17.3337 17.3334 13.6003 17.3334 9.00033C17.3334 4.40033 13.6001 0.666992 9.00008 0.666992ZM9.00008 15.667C5.32508 15.667 2.33341 12.6753 2.33341 9.00033C2.33341 5.32533 5.32508 2.33366 9.00008 2.33366C12.6751 2.33366 15.6667 5.32533 15.6667 9.00033C15.6667 12.6753 12.6751 15.667 9.00008 15.667Z"
      fill="white"
    />
  </SVG>
);

export const RightArrowIcon = () => (
  <SVG
    ariaLabel="Right Arrow Icon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewbox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_8202_12)">
      <path
        d="M5.72656 4.94L8.7799 8L5.72656 11.06L6.66656 12L10.6666 8L6.66656 4L5.72656 4.94Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_8202_12">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(0 -1 1 0 0 16)"
        />
      </clipPath>
    </defs>
  </SVG>
);

export const DeleteIcon = ({ fill }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    height="16"
    viewBox="0 96 960 960"
    width="16"
    fill={fill}
  >
    <path d="M278.309 915.999q-23.529 0-40.611-17.082-17.081-17.082-17.081-40.611V314.078h-40.616v-45.384h171.076v-28.077h257.846v28.077h171.076v45.384h-40.616v544.228q0 23.529-17.081 40.611-17.082 17.082-40.611 17.082H278.309Zm102.923-129.845h45.383V397.539h-45.383v388.615Zm152.153 0h45.383V397.539h-45.383v388.615Z" />
  </SVG>
);
